import { datadogRum } from '@datadog/browser-rum';
import { useEffect, useState } from 'react';
import {
  browserCookieIdExperiments,
  clientSideUserIdExperiments,
  userIdExperiments
} from '~/constants/home/experiments';
import {
  useIsLoggedIn,
  useUserIsImpersonating
} from '~/context/common/UserContext';
import { useGetIsReturnUser } from '~/context/home/GlobalContext';
import useEventExperiments from '~/hooks/common/telemetry/useEventExperiments';
import useSendFeatureBranchToDataDog from '~/hooks/common/telemetry/useSendFeatureBranchToDataDog';
import useSendNativeDeviceTypeToDataDog from '~/hooks/common/telemetry/useSendNativeDeviceTypeToDataDog';

const useSetDataDogContext = () => {
  const isImpersonating = useUserIsImpersonating();
  const isLoggedIn = useIsLoggedIn();
  const isReturningUser = useGetIsReturnUser();
  // Server-side user-id experiments are only preloaded if logged in at the
  // initial request, so freeze this at mount to avoid waiting on it after a
  // later native auth sync.
  const [wasLoggedInAtMount] = useState(isLoggedIn);
  useEventExperiments(
    browserCookieIdExperiments,
    wasLoggedInAtMount ? userIdExperiments : clientSideUserIdExperiments
  );
  useSendFeatureBranchToDataDog();
  useSendNativeDeviceTypeToDataDog();

  useEffect(() => {
    datadogRum.setGlobalContextProperty('isImpersonating', isImpersonating);
    datadogRum.setGlobalContextProperty('isReturningUser', isReturningUser);
  }, [isImpersonating, isReturningUser]);
};

export default useSetDataDogContext;
